export const FETCHING_CIRCLE_SUGGESTIONS = "FETCHING.CIRCLE_SUGGESTIONS";
export const FETCHED_CIRCLE_SUGGESTIONS = "FETCHED.CIRCLE_SUGGESTIONS";
export const FETCHED_CIRCLE_SUGGESTION = "FETCHED.CIRCLE_SUGGESTION";
export const ERROR_FETCHING_CIRCLE_SUGGESTIONS =
  "ERROR.FETCHING_CIRCLE_SUGGESTIONS";
